export const AppRoutes = Object.freeze({
  WALLETS_USER_HISTORY: "/wallets/user/:userId/history",
  B2B_PRICE_LIST_TEMPLATES: "/b2b/price-list-templates",
  B2B_FINANCIAL_HEALTH: "/b2b/financial-health",
  B2B_STOCK_TRANSFERS: "/b2b/stock-transfers",
  B2B_PAYMENT_SLIPS: "/b2b/payment-slips",
  REDEMPTION_RULES: "/redemption-rules",
  B2B_CONSIGNMENT: "/b2b/consignment",
  CASHBACK_RULES: "/cashback-rules",
  CROSS_PROJECTS: "/cross-projects",
  PREORDERS_DESK: "/preorders/desk",
  B2B_LOGISTICS: "/b2b/logistics",
  NOTIFICATIONS: "/notifications",
  SYSTEM_HEALTH: "/system-health",
  B2C_DASHBOARD: "/b2c/dashboard",
  B2B_DASHBOARD: "/b2b/dashboard",
  B2B_COMPANIES: "/b2b/companies",
  TRANSACTIONS: "/transactions",
  MEDIA_ASSETS: "/media-assets",
  B2B_BILLING: "/b2b/billing",
  B2B_ADJUSTMENTS: "/b2b/adjustments",
  B2B_DUNNING: "/b2b/dunning",
  B2B_FINANCE_REPORT: "/b2b/finance-report",
  PERMISSIONS: "/permissions",
  B2B_QUOTES: "/b2b/quotes",
  B2B_ORDERS: "/b2b/orders",
  CATEGORIES: "/categories",
  AUDIT_LOGS: "/audit-logs",
  ADDRESSES: "/addresses",
  INVENTORY: "/inventory",
  SUPPLIERS: "/suppliers",
  RMA_DESK: "/rma/desk",
  PRODUCTS: "/products",
  BO_USERS: "/bo-users",
  SETTINGS: "/settings",
  PROFILE: "/profile",
  WALLETS: "/wallets",
  COUPONS: "/coupons",
  B2B_OBO: "/b2b/obo",
  SIGNUP: "/signup",
  BRANDS: "/brands",
  ORDERS: "/orders",
  LOGIN: "/login",
  USERS: "/users",
  ROLES: "/roles",
  TIERS: "/tiers",
  CARDS: "/cards",
  IPS: "/ips",
  ROOT: "/",
});
